<template>
  <div class="content">
    <Title :title="'主页'"></Title>
    <div class="deposit">
      <div class="left">
        <div class="top">
          <span class="money">{{canWithdraw.toFixed(2)}}</span>
          <span class="unit">元</span>
        </div>
        <div class="bottom">可提现金额 (元)</div>
      </div>
      <div class="right" @click="$router.push('/pc/user/accountWithdrawal')">提现</div>
    </div>
    <div class="data">
      <div class="item">
        <div class="top">
          <div class="left">
            <div class="circle"></div>
            <div class="title">本月新增会员数</div>
          </div>
          <div class="right">{{monthFansCount}}</div>
        </div>

        <div class="bottom">
          <div class="nowMonthData">
            <span>{{todayFansCount}}</span><span class="units">个</span>
          </div>

          <div class="todayData">
            <div>今日新增会员</div>
            <div class="goUp" v-if="todayFansCount >= yesterdayStat.fansCountToday">较昨日上升{{ todayFansCount - yesterdayStat.fansCountToday }}个
              <img src="@/assets/img/open/home_icon_arrow_litre.png" alt="">
            </div>
            <div class="decline" v-else>较昨日下降{{ yesterdayStat.fansCountToday - todayFansCount }}
              <img src="@/assets/img/open/home_icon_arrow_drop.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="top">
          <div class="left">
            <div class="circle"></div>
            <div class="title">本月新增订单数</div>
          </div>
          <div class="right">{{monthOrderCount}}</div>
        </div>

        <div class="bottom">
          <div class="nowMonthData">
            <span>{{todayOrderCount}}</span><span class="units">件</span>
          </div>

          <div class="todayData">
            <div>今日订单数</div>
            <div class="goUp" v-if="todayOrderCount >= yesterdayStat.orderCountToday">较昨日上升{{todayOrderCount - yesterdayStat.orderCountToday}}
              <img src="@/assets/img/open/home_icon_arrow_litre.png" alt="">
            </div>
            <div class="decline" v-else>较昨日下降{{ yesterdayStat.orderCountToday - todayOrderCount }}
              <img src="@/assets/img/open/home_icon_arrow_drop.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="top">
          <div class="left">
            <div class="circle"></div>
            <div class="title">本月结算收入</div>
          </div>
          <div class="right">{{monthCommission.toFixed(2)}}</div>
        </div>

        <div class="bottom">
          <div class="nowMonthData">
            <span>{{todayCommission.toFixed(2)}}</span><span class="units">元</span>
          </div>

          <div class="todayData">
            <div>今日佣金</div>
            <div class="goUp" v-if="todayCommission >= yesterdayStat.commissionToday">较昨日上升{{todayCommission - yesterdayStat.commissionToday}}
              <img src="@/assets/img/open/home_icon_arrow_litre.png" alt="">
            </div>
            <div class="decline" v-else>较昨日下降{{ yesterdayStat.commissionToday - todayCommission }}
              <img src="@/assets/img/open/home_icon_arrow_drop.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-echart">
      <p class="tilte-text">近15日订单数据</p>
      <div class="box">
        <div id="chartColumn" class="echartsStyle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from './components/title.vue'
import echarts from 'echarts'
import { getopenIndexInfo } from '@/api/open.js'

export default {
  name: '',
  components: { Title },
  props: {},
  filters: {},
  data() {
    return {
      test: false,
      chartColumn: null,
      report: {
        dayList: [],
        clickNum: 0,
        validIncome: 0,
        validOrderNum: 0,
        clickNumList: [],
        validIncomeList: [],
        validOrderNumList: []
      },
      monthCommission: 0,
      todayCommission: 0,
      monthOrderCount: 0,
      todayOrderCount: 0,
      monthFansCount: 0,
      todayFansCount: 0,
      canWithdraw: 0,
      yesterdayStat: {
        commissionToday: 0,
        fansCountToday: 0,
        orderCountToday: 0
      },
      // echart数据
      echartsData: {
        dateData: [],
        kfcDate: [],
        electricityDate: []
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$store.getters.appKey.length === 0 && this.$store.getters.userToken !== '') {
      this.$message.warning('请先添加公众号')
      this.$router.push('/pc/open/application')
    }
    if (this.$store.getters.appKey.length > 0) {
      this.getopenIndexInfo()
    }
  },
  mounted() {},
  updated() {
    this.initEcharts()
  },
  activated() {},
  deactivated() {},
  destroyed() {},
  methods: {
    initEcharts() {
      this.chartColumn = echarts.init(document.getElementById('chartColumn'))
      // v1.1
      this.chartColumn.setOption({
        xAxis: {
          type: 'category',
          data: this.echartsData.dateData,
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: '#FA6F53'
            }
          },
          boundaryGap: false, //坐标轴两边不留白
          name: '' //X轴 name
        },
        yAxis: {
          type: 'value',
          name: '',
          nameTextStyle: {
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: '#FA6F53'
            }
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['肯德基', '电费充值']
        },
        series: [
          {
            name: '肯德基',
            data: this.echartsData.kfcDate,
            type: 'line',
            color: ['#0000FF'],
            label: {
              // show: true
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            }
          },
          {
            name: '电费充值',
            data: this.echartsData.electricityDate,
            type: 'line',
            color: ['#FA6F53'],
            label: {
              // show: true
              normal: {
                show: false
              },
              emphasis: {
                show: true
              }
            }
          }
        ]
      })

      // v1.0
      // this.chartColumn.setOption({
      //   tooltip: {
      //     //设置tip提示
      //     trigger: 'axis'
      //   },
      //   xAxis: {
      //     type: 'category',
      //     data: this.echartsData.dateData,
      //     nameTextStyle: {
      //       //坐标轴名称的文字样式
      //       color: '#FA6F53',
      //       fontSize: 24,
      //       padding: [0, 0, 0, 20]
      //     },
      //     axisLine: {
      //       //坐标轴轴线相关设置。
      //       lineStyle: {
      //         color: '#FA6F53'
      //       }
      //     },
      //     boundaryGap: false, //坐标轴两边不留白
      //     name: '' //X轴 name
      //   },
      //   yAxis: {
      //     type: 'value',
      //     name: '',
      //     nameTextStyle: {
      //       color: '#FA6F53',
      //       fontSize: 16,
      //       padding: [0, 0, 10, 0]
      //     },
      //     axisLine: {
      //       lineStyle: {
      //         color: '#FA6F53'
      //       }
      //     }
      //   },
      //   series: [
      //     {
      //       name: '肯德基',
      //       data: this.echartsData.kfcDate,
      //       type: 'line',
      //       color: ['#FA6F53'],
      //       label: {
      //         show: true
      //         // normal: {
      //         //   show: false
      //         // },
      //         // emphasis: {
      //         //   show: true
      //         // }
      //       }
      //     }
      //   ]
      // })
      // console.log('this.echartsData.dateData', this.echartsData.dateData)
    },
    // 获取数据
    getopenIndexInfo() {
      getopenIndexInfo({
        // appKey: 15720601971
        appKey: this.$store.getters.showAppKey.appKey
      }).then(res => {
        // console.log('res', res)

        // 总览
        this.monthCommission = res.data.monthCommission
        this.todayCommission = res.data.todayCommission
        this.monthOrderCount = res.data.monthOrderCount
        this.todayOrderCount = res.data.todayOrderCount
        this.monthFansCount = res.data.monthFansCount
        this.todayFansCount = res.data.todayFansCount
        this.canWithdraw = res.data.canWithdraw
        if (res.data.yesterdayStat !== '' && res.data.yesterdayStat !== null) {
          this.yesterdayStat = res.data.yesterdayStat
        }

        // 图表
        // this.echartsData = this.$options.data().echartsData
        res.data.statList.map((item, index, array) => {
          this.echartsData.dateData.push(item.statTime.substring(5, 10))
          // v1.0
          // this.echartsData.kfcDate.push(item.orderCountToday)
          // v1.1
          this.echartsData.kfcDate.push(item.kfcOrderCountToday)
          this.echartsData.electricityDate.push(item.electricityOrderCountToday)
        })
        console.log('this.echartsData',this.echartsData)
        this.initEcharts()
      })
    }
  }
}
</script>
<style lang='less' scoped>
.content {
  .deposit {
    width: 100%;
    height: 126px;
    background-image: url(../../../assets/img/open/home_withdrawal_bg.png);
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 75px 0 40px;
    margin-top: 11px;

    .left {
      .top {
        .money {
          font-size: 28px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #ffffff;
        }
        .unit {
          margin-left: 10px;
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          // color: #ffffff;
          color: rgba(255, 255, 255, 0.8);
        }
      }
      .bottom {
        font-size: 16px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        // color: #ffffff;
        color: rgba(255, 255, 255, 0.5);
      }
    }
    .right {
      width: 100px;
      height: 42px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #1287ea;
      text-align: center;
      line-height: 42px;
      cursor: pointer;
    }
  }
  .data {
    display: flex;
    justify-content: space-between;
    margin-top: 22px;

    .item {
      margin-right: 20px;
      height: 174px;
      background: #fafafa;
      border-radius: 4px;
      width: 100%;
      padding: 20px;
      position: relative;

      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          align-items: center;

          .circle {
            width: 10px;
            height: 10px;
            border: 4px solid #ff8622;
            border-radius: 50%;
            margin-right: 5px;
          }
          .title {
            height: 22px;
            font-size: 13px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #666666;
            line-height: 22px;
          }
        }
        .right {
          font-size: 16px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          position: relative;
          top: -5px;
        }
      }
      .bottom {
        position: absolute;
        bottom: 20px;
        .nowMonthData {
          margin-bottom: 2px;
          font-size: 32px;
          font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #222222;
          .units {
            margin-left: 5px;
            font-size: 12px;
            font-weight: 400;
          }
        }
        .todayData {
          font-size: 13px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #666666;
          display: flex;
          align-items: center;
          :first-child {
            margin-right: 8px;
          }
          .goUp {
            color: #30b583;
          }
          .decline {
            color: #ff4f76;
          }
          img {
            width: 18px;
            height: 18px;
            position: relative;
            left: -5px;
          }
        }
      }
    }
    .item:last-child {
      margin-right: 0;
    }
  }
  .data-echart {
    margin-top: 22px;
    p {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      margin-bottom: 20px;
    }
    .box {
      width: 100%;
      border-radius: 4px;
      border: 1px solid #eeeeee;
      height: 295px;
      padding: 2px 6px;

      .echartsStyle {
        width: 100%;
        height: 100%;
        margin: 0 auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/home.vue